import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UnauthorizedRoutingModule } from './unauthorized-routing.module';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { InnerHtmlDialogModule } from '../dialog/inner-html-dialog/inner-html-dialog.module';



@NgModule({
  declarations: [
    UnauthorizedComponent
  ],
  imports: [
    CommonModule,
    MatCheckboxModule,
    MatMenuModule,
    MatDialogModule,
    TranslateModule,
    MatButtonModule,
    InnerHtmlDialogModule,
    UnauthorizedRoutingModule

  ]
})
export class UnauthorizedModule { }
